import objectUtils from '../utils/object-utils'

export default class AppMessage {
  constructor (options = {}) {
    this.model = 'AppMessage'
    this.source = objectUtils.get(options, 'source', null)
    this.status_code = objectUtils.get(options, 'status_code', null)
    this.severity = objectUtils.get(options, 'severity', 'success') // 'info', 'warning', 'error', 'success'
    this.action_link = objectUtils.get(options, 'action_link', null)
    this.text = objectUtils.get(options, 'text', generateAppMessage(this))
  }
}

function generateAppMessage (data) {
  const status = data.status_code || 0
  const id = (data.source && data.source.id) ? data.source.id : null
  const name = (data.source && data.source.name) ? data.source.name : null
  const label = name || id
  switch (status.toString()) {
    case '200': return (label) ? `Updated (${label})` : 'Updated'
    case '201': return (label) ? `Created (${label})` : 'Created'
    case '204': return (label) ? `Deleted (${label})` : 'Deleted'
    default: return `${data.severity} [${data.status_code}]`
  }
}
